import styled from "styled-components";
import Text from "../text";

const Subtitle = styled(Text)`
  font-size: 18px;
`;

export default Subtitle;
